import React, {useState} from 'react'
import {Button, Input, message, Modal, Popconfirm, Select} from "antd";
import {addTenantFee} from "../../../../../../services/api/apiCustomerHub";
import {Option} from "antd/es/mentions";
import parseToken from "../../../../../../helpers/parseToken";

function TenantFeeAddModal(props) {
    const {custId, listTelco, isOpen, toggleModal, fetchTenantFee} = props
    const [validate, setValidate] = useState({})
    const [loading, setLoading] = useState(false)
    const [itemNew, setItemNew] = useState({})
    const decodeToken = parseToken()

    const handleCancel = () => {
        toggleModal()
    }

    const handleChangeItemNew = (name, value) => {
        setItemNew({
            ...itemNew,
            [name]: name === 'priority' ? parseInt(value) : value
        })
    }

    const _validateData = () => {
        let validateForm = {}
        if (itemNew?.description === undefined) {
            Object.assign(validateForm, {description: 'Gói cước là bắt buộc'})
        }
        if (itemNew?.callerPrefix === undefined) {
            Object.assign(validateForm, {callerPrefix: 'Hướng là bắt buộc'})
        }
        if (itemNew?.calledPrefix === undefined) {
            Object.assign(validateForm, {calledPrefix: 'Hướng là bắt buộc'})
        }
        if (itemNew?.fee === undefined) {
            Object.assign(validateForm, {fee: 'Giá là bắt buộc'})
        }

        setValidate(validateForm)

        return validateForm
    }

    const _addTenantFee = async () => {
        try {
            setLoading(true)
            const validateCheck = _validateData()
            if (Object.keys(validateCheck).length > 0) {
                setLoading(false)
                message.error("Dữ liệu không hợp lệ")
                return false
            }
            const payload = {
                ...itemNew,
                telco: `${itemNew?.callerPrefix}_${itemNew?.calledPrefix}`,
                tenantId: custId
            }
            const response = await addTenantFee(decodeToken.sub, payload)
            setLoading(false)
            const {success, error_message} = response
            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
            message.success('Thêm mới thành công!')
            toggleModal()
            fetchTenantFee()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    return (
        <Modal
            title="Thêm mới Giá cước"
            className={`ModalCustom2`}
            style={{top: 20}}
            maskClosable={false}
            open={isOpen}
            footer={[
                <div className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleCancel} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disable={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" onClick={_addTenantFee} loading={loading}>
                        Save
                    </Button>
                </div>
            ]}
        >
            <div className="FormEdit">
                <div className="row">
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Gói cước
                            <span className="Required">*</span>
                        </label>
                        <Input onChange={(e) => handleChangeItemNew('description', e.target.value)} type="text"/>
                        {
                            validate?.description &&
                            <span className="Error text-danger mt-1">{validate?.description}</span>
                        }
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Hướng
                            <span className="Required">*</span>
                        </label>
                        <div className="row">
                            <div className="col-md-6">
                                <Select className="mr-3"
                                        onChange={(value) => handleChangeItemNew('callerPrefix', value)}
                                        placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                                    {
                                        listTelco.map(item => {
                                            return <Option value={item.code} key={item.code}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                {
                                    validate?.callerPrefix &&
                                    <span className="Error text-danger mt-1">{validate?.callerPrefix}</span>
                                }
                            </div>
                            <div className="col-md-6">
                                <Select onChange={(value) => handleChangeItemNew('calledPrefix', value)}
                                        placeholder="Chọn" style={{width: '100%', minWidth: '150px'}}>
                                    {
                                        listTelco.map(item => {
                                            return <Option value={item.code} key={item.code}>{item.name}</Option>
                                        })
                                    }
                                </Select>
                                {
                                    validate?.calledPrefix &&
                                    <span className="Error text-danger mt-1">{validate?.calledPrefix}</span>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="FormField col-md-12">
                        <label className="Label">
                            Giá
                            <span className="Required">*</span>
                        </label>
                        <Input onChange={(e) => handleChangeItemNew('fee', e.target.value)} type="number"/>
                        {
                            validate?.fee && <span className="Error text-danger mt-1">{validate?.fee}</span>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default TenantFeeAddModal
